import Alpine from 'alpinejs';
import intersect from '@alpinejs/intersect';
import collapse from '@alpinejs/collapse';
import lazySizes from 'lazysizes';
import gsap from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Swup from 'swup';
import EmblaCarousel from 'embla-carousel';
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures';
import Fade from 'embla-carousel-fade';
import Autoplay from 'embla-carousel-autoplay';
import './disableCookies';


// ==========================================================================
// 🌄 Alpine.js Setup
// ==========================================================================
gsap.registerPlugin(ScrollTrigger);

window.Alpine = Alpine;
Alpine.plugin(intersect);
Alpine.plugin(collapse);
Alpine.start();

// ==========================================================================
// 🌍 Global Variables
// ==========================================================================
const nav = document.querySelector('.nav');
const body = document.body;
const isMobile = window.matchMedia("only screen and (max-width: 768px)").matches;

// ==========================================================================
// 🧮 Utility Functions
// ==========================================================================
const easeInOutQuad = t => t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
const easeInCubic = t => t * t * t;
const easeOutCubic = t => 1 - Math.pow(1 - t, 3);

// ==========================================================================
// 🚀 Scroll Animations Setup
// ==========================================================================
const initAnimations = () => {
  console.log("🎬 Animations initialized");
};

// ==========================================================================
// 🔗 Navigation State
// ==========================================================================
const setActiveNav = () => {
  const nav = document.querySelector('#nav');
  if (!nav) return;
  const currentSlug = window.location.pathname.replace(/\/$/, '') || '/';
  nav.querySelectorAll('.nav__link a').forEach(link => {
    const href = link.getAttribute('href');
    if (!href) return;
    const linkSlug = new URL(href, window.location.origin).pathname.replace(/\/$/, '') || '/';
    link.classList.toggle('active', linkSlug === currentSlug);
  });
};

// ==========================================================================
// 🏠 Home Page Check
// ==========================================================================
const checkHomePage = () => {
  body.classList.toggle('body--home', window.location.pathname === '/' || window.location.href === window.location.origin + '/');
};

// ==========================================================================
// 📱 Remove <br> on Mobile
// ==========================================================================
const removeBr = el => {
  if (window.innerWidth <= 768) {
    const item = document.querySelector(el);
    if (item) item.innerHTML = item.innerHTML.replace(/<br\s*\/?>(\s*)?/gi, " ");
  }
};

// ==========================================================================
// ✨ GSAP Fade-Up Animation
// ==========================================================================
function fadeUp() {
  const els = document.querySelectorAll('.f-up');
  gsap.set(els, { opacity: 0, y: 30 });
  ScrollTrigger.batch(els, {
    start: "top 90%",
    onEnter: batch => {
      gsap.to(batch, {
        opacity: 1,
        y: 0,
        stagger: 0.15,
        duration: 0.6,
        ease: "power2.out",
        onComplete: function () {
          this.targets().forEach(el => {
            el.classList.remove('f-up');
            el.classList.add('faded');
          });
        }
      });
    },
    once: true
  });

  let sTimeout;
  const scrollHandler = () => {
    clearTimeout(sTimeout);
    sTimeout = setTimeout(() => {
      const missedEls = [];
      document.querySelectorAll('.f-up').forEach(el => {
        const r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) missedEls.push(el);
      });
      if (missedEls.length) {
        gsap.to(missedEls, {
          opacity: 1,
          y: 0,
          stagger: 0.15,
          duration: 0.4,
          ease: "power2.out",
          onComplete: function () {
            this.targets().forEach(el => {
              el.classList.remove('f-up');
              el.classList.add('faded');
            });
          }
        });
      }
    }, 150);
  };
  window.addEventListener('scroll', scrollHandler);

  return () => {
    window.removeEventListener('scroll', scrollHandler);
    ScrollTrigger.getAll().forEach(st => st.kill());
  };
}

// ==========================================================================
// 🚦 Page Transitions (Swup)
// ==========================================================================
// const swup = new Swup();
// swup.hooks.on('visit:start', () => {
//   document.documentElement.classList.add("loading");
//   document.documentElement.classList.remove("loaded");
//   return new Promise(resolve => setTimeout(resolve, 250));
// });

// swup.hooks.on('page:view', () => {
//   document.documentElement.classList.add("loaded");
//   document.documentElement.classList.remove("loading");
//   init();
// });

// swup.hooks.on('content:replace', () => {
//   reloadTurnstile();
// });

function reloadTurnstile() {
  console.log("🔄 Reloading Turnstile");
  if (typeof turnstile === 'undefined') return;

  document.querySelectorAll('.cf-turnstile').forEach(container => {
    if(turnstile) {
      console.log("🔄 Removing existing Turnstile instance and rerender");
      turnstile.remove(container);
      turnstile.render(container);
    } else {
      console.log("🔄 load turnstile first time");
      turnstile.render(container);
    }
  });
}



// document.addEventListener("DOMContentLoaded", function () {
//   const adminBar = document.querySelector(".admin-bar");
//   if (adminBar) {
//     document.body.appendChild(adminBar);
//   }
// });


// ==========================================================================
// 🏁 Init Navigation
// ==========================================================================

function initNavHoverState() {
  // const navLinks = document.querySelectorAll('.nav__link');

  // navLinks.forEach(link => {
  //   const sublinks = link.querySelector('.nav__sublinks');
  //   if (!sublinks) return;

  //   let hideTimeout;

  //   const show = () => {
  //     clearTimeout(hideTimeout);
  //     sublinks.classList.add('active');
  //   };

  //   const hide = () => {
  //     hideTimeout = setTimeout(() => {
  //       sublinks.classList.remove('active');
  //     }, 100);
  //   };

  //   link.addEventListener('mouseenter', show);
  //   link.addEventListener('mouseleave', hide);
  //   sublinks.addEventListener('mouseenter', show);
  //   sublinks.addEventListener('mouseleave', hide);
  // });
}


// ==========================================================================
// 🛠️ Fix admin bar url
// ==========================================================================

function updateAdminBarEditLink() {
  const editLink = document.querySelector('.admin-bar__link--highlight');
  if (!editLink) return;

  // Get current pathname and clean it up
  const path = window.location.pathname.replace(/^\/+|\/+$/g, '');

  // Handle home page separately if needed
  const panelSlug = path === '' ? 'home' : path.replace(/\//g, '+');

  const panelOrigin = window.location.origin.replace(/\/$/, '');
  editLink.href = `${panelOrigin}/panel/pages/${panelSlug}`;
}



// ==========================================================================
// 🏁 Main Init Function
// ==========================================================================



const init = () => {
  checkHomePage();
  lazySizes.init();
  initAnimations();
  removeBr('h1');
  setActiveNav();
  initNavHoverState();
  fadeUp();
  updateAdminBarEditLink();
};

document.addEventListener('DOMContentLoaded', init);
document.addEventListener('swup:contentReplaced', init);
